module.exports = __webpack_public_path__ + "static/img/about_us3.eeee371.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_us3.png
// module id = DO5r
// module chunks = 0